import { Link } from '@tanstack/react-router'
import type { OperatorSession } from '@marque/api/central'

interface SidebarProps {
    session: OperatorSession
}

const NAV_ITEMS = [
    { to: '/' as const, label: 'Dashboard' },
    { to: '/tenants' as const, label: 'Tenants' },
    { to: '/bundles' as const, label: 'Module Bundles' },
    { to: '/modules' as const, label: 'Modules' },
    { to: '/role-templates' as const, label: 'Role Templates' },
    { to: '/settings/smtp' as const, label: 'SMTP' },
]

export function Sidebar({ session }: SidebarProps) {
    return (
        <aside className="w-52 shrink-0 min-h-screen bg-white border-r border-neutral-200 flex flex-col">
            <div className="px-4 py-4 border-b border-neutral-100">
                <span className="font-semibold text-sm text-neutral-900">Marque Central</span>
            </div>

            <nav className="flex-1 px-2 py-3 space-y-0.5">
                {session.permissions.includes('central.styles:read') && <Link to="/settings/style-presets" className="block px-3 py-2 rounded-md text-sm">Style presets</Link>}
                {NAV_ITEMS.map(({ to, label }) => (
                    <Link
                        key={to}
                        to={to}
                        className="block px-3 py-2 rounded-md text-sm transition-colors"
                        activeProps={{ className: 'bg-neutral-100 text-neutral-900 font-medium' }}
                        inactiveProps={{ className: 'text-neutral-600 hover:bg-neutral-50 hover:text-neutral-900' }}
                    >
                        {label}
                    </Link>
                ))}
            </nav>

            <div className="px-4 py-4 border-t border-neutral-100 space-y-2">
                <div className="flex items-center gap-2 text-xs text-neutral-500 min-w-0">
                    <span className="truncate">{session.displayName}</span>
                    <span className="shrink-0 bg-neutral-100 px-1.5 py-0.5 rounded text-[10px]">{session.env}</span>
                </div>
                <form method="post" action="/bff/signout">
                    <button type="submit" className="text-xs text-neutral-500 hover:text-neutral-900 transition-colors">
                        Sign out
                    </button>
                </form>
            </div>
        </aside>
    )
}
